import { useState } from "react";
import { HeaderWrapper } from "./HeaderWrapper";
import { ChevronIcon } from "~/assets/icons/Chevron";

export const OrderBy = ({
  options,
  label,
  onClick,
}: {
  options: { label: string; value: string; active: boolean }[];
  label: string;
  onClick: (orderby: string) => void;
}) => {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <div>
      <div
        className="relative h-full cursor-pointer"
        onClick={() => setIsOpen(!isOpen)}
      >
        <HeaderWrapper>
          <div className="mr-4 flex flex-row">
            <div className="hidden whitespace-pre md:block">Raða eftir: </div>
            <div>{label}</div>
          </div>
          <ChevronIcon direction={isOpen ? "up" : "down"} />
        </HeaderWrapper>
        {isOpen && (
          <div className="absolute top-10 z-10 block w-full shadow-sm">
            <div className="flex flex-col items-center justify-between border-0.5 bg-white shadow-sm">
              {options.map((option) => {
                return (
                  <div
                    key={option.value}
                    onClick={() => {
                      onClick(option.value);
                      setIsOpen(false);
                    }}
                    className="h-10 w-full cursor-pointer hover:bg-primary"
                  >
                    <div
                      className={`flex h-full flex-row items-center justify-center ${
                        option.active ? "font-semibold" : ""
                      }`}
                    >
                      {option.label}
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
